// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RFF9Q","left":"styles_left__3znzc","desktopActions":"styles_desktopActions__1b9OK","title":"styles_title__32CjD"};